import React, { PureComponent } from 'react';
import { Row } from 'reactstrap';
import { mapCloudTypeToDisplayLabelFunc } from 'shared/utils/cloudUtils';
import LabelCoordinator from 'shared/modules/labelCoordinator';
import If from 'shared/components/SimpleIf';
import {
  GroupByLovToAttributes,
  K8sGroupByLovToAttributes,
  mapGroupByCloudBasedLov,
  mapK8SGroupByCloudBasedLov,
  NEW_AZURE_FOCUS_FIELDS,
  removeDoubleCostCenterInKeyCloakManagement,
  RESELLER_ONLY_FIELDS,
  UNIFIED_K8S_GROUP_BY_LOV,
} from 'usage/constants/costAndUsageConstants';
import GroupByFilterButton from 'shared/components/GroupByFilterButton';
import { CLOUD_TYPE_IDS } from 'users/constants/usersConstants';
import { GCPCommonFieldLabels, GcpCommonFields } from 'shared/constants/gcpConstants';
import { AwsCommonFields } from 'shared/constants/awsConstants';
import { k8sCommonFieldToDisplayField, k8sGranLevel } from '~/shared/constants/k8sConstants.js';
import { k8sGroupByNodesFields, k8sGroupByPodsFields } from '~/kubernetes/constants/k8sConstants.js';
import K8sGranularityToggle from '~/kubernetes/containers/KubernetesDashboard/components/K8sGranularityToggle/K8sGranularityToggle.jsx';
import styles from './FilterBar.module.scss';

class FilterBar extends PureComponent {
  constructor() {
    super();
  }

  getFilterLabel = (field) => {
    const { page } = this.props;
    if (page === 'k8s-cue') {
      return k8sCommonFieldToDisplayField.get(field) || LabelCoordinator.getFieldLabel(field);
    }
    const label = LabelCoordinator.getFieldLabel(field);
    return label;
  };

  formatFiltersByNodesOrPods = (groupByItems) => {
    const { kubernetesStore, usersStore } = this.props;
    if (usersStore.currDispUserCloudAccountType !== CLOUD_TYPE_IDS.GCP) {
      return;
    }
    let fieldsToRemove = [];
    if (kubernetesStore.k8SGranularity === k8sGranLevel.NODES) {
      fieldsToRemove = k8sGroupByPodsFields;
      // todo - remove this when group by tags/labels will be supported when granularity is by nodes
      fieldsToRemove.push(LabelCoordinator.getFieldLabelByCloudType(GcpCommonFields.CUSTOM_TAGS, CLOUD_TYPE_IDS.GCP));
    } else {
      fieldsToRemove = k8sGroupByNodesFields;
    }
    fieldsToRemove.forEach((groupByKey) => {
      const groupByKeyIndex = groupByItems.findIndex(
        (item) => item === (k8sCommonFieldToDisplayField.get(groupByKey) || groupByKey),
      );
      if (groupByKeyIndex > -1) {
        groupByItems.splice(groupByKeyIndex, 1);
      }
    });
  };

  addCustomTagsGroupByValues = (
    arrCustomTagsKeys = [],
    arrVirtualTagsNames = [],
    arrViewsNames = [],
    arrAccountTagsKeys = [],
    arrBusinessMappingViewpoints = [],
    arrWorkloadTypes = [],
    arrK8STagsKeys = [],
    groupByItems,
    isShowCustomTags,
  ) => {
    const { currentCloudType, isAllAcounts = false, usersStore, page } = this.props;
    if (isAllAcounts) {
      groupByItems.push('Payer Account');
    }

    const attributes = page === 'k8s-cue' ? K8sGroupByLovToAttributes : GroupByLovToAttributes;
    if (!isShowCustomTags) {
      return { secondLevelItems: [], secondLevelItemsValuesMap: attributes };
    }
    const secondLevelItemsValuesMap = new Map(attributes);
    if (arrBusinessMappingViewpoints?.length) {
      groupByItems.push('Business Mapping Viewpoints');
    }
    if (arrCustomTagsKeys?.length) {
      groupByItems.push(LabelCoordinator.getFieldLabelByCloudType('tags', currentCloudType));
    }
    if (arrVirtualTagsNames?.length) {
      groupByItems.push('Virtual Tags');
    }
    if (arrViewsNames?.length) {
      groupByItems.push('Views');
    }
    if ((arrAccountTagsKeys || []).length) {
      groupByItems.push('Enrichment Tags');
    }
    if (usersStore.getIsK8SAndCueK8SMergedFeatureEnabled() || page === 'k8s-cue') {
      if ((arrWorkloadTypes || []).length) {
        groupByItems.push('Workload');
      }
      if (arrK8STagsKeys?.length) {
        groupByItems.push(LabelCoordinator.getFieldLabelByCloudType('k8scustomtags', currentCloudType));
      }
    }
    const secondLevelItems = [];
    (arrViewsNames || []).forEach(({ name }) => {
      const viewTagDisplay = `viewsTag:${name}`;
      secondLevelItemsValuesMap.set(viewTagDisplay, `viewscustomtags:${name}`);
      secondLevelItems.push(viewTagDisplay);
    });
    (arrVirtualTagsNames || []).forEach(({ name }) => {
      const virtualTagDisplay = `virtualTag:${name}`;
      secondLevelItemsValuesMap.set(virtualTagDisplay, `virtualcustomtags:${name}`);
      secondLevelItems.push(virtualTagDisplay);
    });
    (arrCustomTagsKeys || []).forEach((item) => {
      const customTagDispaly = `customTag:${item}`;
      if (item) {
        secondLevelItemsValuesMap.set(customTagDispaly, `customtags:${item}`);
        secondLevelItems.push(customTagDispaly);
      }
    });
    (arrAccountTagsKeys || []).forEach((item) => {
      const customTagDisplay = `accountTag:${item}`;
      if (item) {
        secondLevelItemsValuesMap.set(customTagDisplay, `accounttags:${item}`);
        secondLevelItems.push(customTagDisplay);
      }
    });
    (arrBusinessMappingViewpoints || []).forEach((item) => {
      const id = `${AwsCommonFields.BUSINESS_MAPPING_VIEWPOINTS}: ${item.id}`;
      const display = `${AwsCommonFields.BUSINESS_MAPPING_VIEWPOINTS}: ${item.name}`;
      if (item) {
        secondLevelItemsValuesMap.set(display, id);
        secondLevelItems.push(display);
      }
    });
    arrK8STagsKeys.forEach((item) => {
      const customTagDispaly = `label: ${item}`;
      if (item) {
        secondLevelItemsValuesMap.set(customTagDispaly, `labels:${item}`);
        secondLevelItems.push(customTagDispaly);
      }
    });
    arrWorkloadTypes.forEach((item) => {
      const tagDisplay = `workloadvalue:${item}`;
      if (item) {
        secondLevelItemsValuesMap.set(tagDisplay, `workloadvalue:${item}`);
        secondLevelItems.push(tagDisplay);
      }
    });
    return { secondLevelItems, secondLevelItemsValuesMap };
  };
  addItemsToSecondaryGroupBy = (groupByItemsSecondary, accountId, arrViewsNames) => {
    if (arrViewsNames && arrViewsNames.length) {
      groupByItemsSecondary.push('Views');
    }
  };

  formatValueLabelItems = (groupByItems) => {
    const { currentCloudType = [], usersStore } = this.props;
    const filteredItems = groupByItems
      .filter((item) => usersStore.isCurrentUserReseller || !RESELLER_ONLY_FIELDS.includes(item))
      .filter(
        (item) =>
          usersStore.getIsCurrentAccountAzureFocus ||
          !NEW_AZURE_FOCUS_FIELDS.includes(GroupByLovToAttributes.get(item)),
      );
    if (currentCloudType !== CLOUD_TYPE_IDS.GCP) {
      return filteredItems;
    }
    const groupBy = filteredItems.map((item) => ({ value: item, label: GCPCommonFieldLabels.get(item) || item }));
    return groupBy;
  };

  formatSelectedItem = (selectedItem) => {
    const { currentCloudType } = this.props;
    if (currentCloudType !== CLOUD_TYPE_IDS.GCP) {
      return selectedItem;
    }
    return GCPCommonFieldLabels.get(selectedItem) || selectedItem;
  };

  getGroupBysByPage = () => {
    const { appStore, usersStore, page, fieldsToRemove } = this.props;
    const items = this.getGroupBysByPageHelper();
    removeDoubleCostCenterInKeyCloakManagement(items, appStore.isKeyCloakManagement, usersStore.isCurrentUserReseller);
    if (page === 'k8s-cue') {
      this.formatFiltersByNodesOrPods(items);
    }
    if (fieldsToRemove?.length) {
      return items.filter(
        (item) => !fieldsToRemove.includes(item) && !fieldsToRemove.includes(GroupByLovToAttributes.get(item)),
      );
    }
    return items;
  };

  getGroupBysByPageHelper = () => {
    const { page, currentCloudType, usersStore } = this.props;
    const drillDownModeK8sFFOff = !usersStore.getIsK8SAndCueK8SMergedFeatureEnabled() && page === 'cue-drill-down';
    if (page === 'k8s-cue') {
      return Object.values(mapK8SGroupByCloudBasedLov.get(currentCloudType));
    }
    if (page === 'cloud-cue' || drillDownModeK8sFFOff) {
      return Object.values(mapGroupByCloudBasedLov.get(currentCloudType));
    }
    return Array.from(
      new Set([
        ...Object.values(mapGroupByCloudBasedLov.get(currentCloudType)),
        ...Object.values(UNIFIED_K8S_GROUP_BY_LOV),
      ]),
    );
  };

  render() {
    const {
      isGroupByValid,
      topLevelGroupBy,
      topLevelSecondaryGroupBy,
      handleGroupByChange,
      renderGroupByButton,
      currentCloudType,
      isShowCustomTags,
      usersStore,
      arrCustomTagsKeys = [],
      arrAccountTagsKeys = [],
      arrBusinessMappingViewpoints = [],
      arrVirtualTagsNames,
      arrViewsNames = [],
      arrWorkloadTypes = [],
      arrK8STagsKeys = [],
      page,
      kubernetesStore,
    } = this.props;
    if (currentCloudType == null) {
      return null;
    }

    const groupByItems = this.getGroupBysByPage();

    // CURRENTLY DISABLING CUSTOM TAGS
    const { secondLevelItems, secondLevelItemsValuesMap } = this.addCustomTagsGroupByValues(
      arrCustomTagsKeys,
      arrVirtualTagsNames,
      arrViewsNames,
      arrAccountTagsKeys,
      arrBusinessMappingViewpoints,
      arrWorkloadTypes,
      arrK8STagsKeys,
      groupByItems,
      isShowCustomTags,
    );
    const displayLabelCloudBaseMap = mapCloudTypeToDisplayLabelFunc.get(currentCloudType);
    const groupByItemsSecondary = groupByItems.filter(
      (item) => item !== 'Virtual Tags' && item !== 'Views' && item !== '- None -' && item !== 'Labels',
    );
    groupByItemsSecondary.unshift('Date');
    const { currDispUserAccountKey } = usersStore;
    this.addItemsToSecondaryGroupBy(
      groupByItemsSecondary,
      usersStore.getCurrentDisplayedAccountId(currDispUserAccountKey),
      arrViewsNames,
    );
    const groupByItemsSecondaryValueLabel = this.formatValueLabelItems(groupByItemsSecondary);
    const isDisabled = topLevelGroupBy && topLevelGroupBy.includes('customtag');
    const groupByValuesLabels = this.formatValueLabelItems(groupByItems);
    const selectedItem = this.getFilterLabel(
      displayLabelCloudBaseMap(
        topLevelGroupBy,
        secondLevelItemsValuesMap,
        usersStore.rootStore.appStore.isKeyCloakManagement,
      ),
    );
    const selectedLabel = this.formatSelectedItem(selectedItem);
    const secondarySelectedItem = this.getFilterLabel(
      displayLabelCloudBaseMap(
        topLevelSecondaryGroupBy,
        secondLevelItemsValuesMap,
        usersStore.rootStore.appStore.isKeyCloakManagement,
      ),
    );
    const secondarySelectedLabel = this.formatSelectedItem(secondarySelectedItem);
    const k8sFields = [
      ...Object.values(UNIFIED_K8S_GROUP_BY_LOV),
      'Workload',
      LabelCoordinator.getFieldLabelByCloudType('k8scustomtags', currentCloudType),
    ];
    if (page === 'cue-drill-down') {
      const items = this.formatValueLabelItems(this.getGroupBysByPage());
      const drillDownTabs = usersStore.getIsK8SAndCueK8SMergedFeatureEnabled()
        ? [
            {
              label: 'Cloud',
              value: 'cloud',
              items: items.filter((v) => !k8sFields.includes(v.value || v)),
            },
            {
              label: 'K8s',
              value: 'k8s',
              items: items.filter((v) => k8sFields.includes(v.value || v)),
            },
          ]
        : null;
      return (
        <div className={styles.nextDrillButtonContainer}>
          <GroupByFilterButton
            secondLevelItems={[]}
            tabs={drillDownTabs}
            title="Next Drill: "
            isSecondary={false}
            items={groupByValuesLabels}
            handler={handleGroupByChange}
            selectedItem={selectedLabel}
            itemsValuesMap={secondLevelItemsValuesMap}
            isIconButton
            currentCloudType={currentCloudType}
            usersStore={usersStore}
            automationid="nextDrill"
            className={styles.nextDrillButton}
          />
        </div>
      );
    }
    const tabs =
      usersStore.getIsK8SAndCueK8SMergedFeatureEnabled() && page === 'merged-cue'
        ? [
            {
              label: 'Cloud',
              value: 'cloud',
              items: groupByValuesLabels.filter((v) => !k8sFields.includes(v.value || v)),
            },
            {
              label: 'K8s',
              value: 'k8s',
              items: groupByValuesLabels.filter((v) => k8sFields.includes(v.value || v)),
            },
          ]
        : undefined;
    const tabsSecondary =
      usersStore.getIsK8SAndCueK8SMergedFeatureEnabled() && page === 'merged-cue'
        ? [
            {
              label: 'Cloud',
              value: 'cloud',
              items: groupByItemsSecondaryValueLabel.filter((v) => !k8sFields.includes(v.value || v)),
            },
            {
              label: 'K8s',
              value: 'k8s',
              items: groupByItemsSecondaryValueLabel.filter((v) => k8sFields.includes(v.value || v)),
            },
          ]
        : undefined;
    return (
      <If cond={renderGroupByButton}>
        <Row>
          {page === 'k8s-cue' && <K8sGranularityToggle usersStore={usersStore} kubernetesStore={kubernetesStore} />}
          <div
            className="filter-bar-inner-col-wrapper-stretch cue-filter-bar"
            style={{ marginLeft: '15px', marginRight: '15px' }}
          >
            <GroupByFilterButton
              tabs={tabs}
              title="Group By: "
              isSecondary={false}
              items={groupByValuesLabels}
              handler={handleGroupByChange}
              selectedItem={selectedLabel}
              itemsValuesMap={secondLevelItemsValuesMap}
              isIconButton
              secondLevelItems={secondLevelItems}
              secondLevelItemsValuesMap={secondLevelItemsValuesMap}
              isGroupByValid={isGroupByValid}
              currentCloudType={currentCloudType}
              usersStore={usersStore}
              automationid="primaryGroupBy"
            />
          </div>
          <div className="filter-bar-inner-col-wrapper-stretch cue-filter-bar" style={{ marginRight: '15px' }}>
            <GroupByFilterButton
              tabs={tabsSecondary}
              title="By: "
              isSecondary
              items={groupByItemsSecondaryValueLabel}
              handler={handleGroupByChange}
              selectedItem={secondarySelectedLabel}
              itemsValuesMap={secondLevelItemsValuesMap}
              isIconButton
              secondLevelItems={secondLevelItems}
              isDisabled={isDisabled}
              isGroupByValid={isGroupByValid}
              currentCloudType={currentCloudType}
              usersStore={usersStore}
              automationid="secondaryGroupBy"
            />
          </div>
        </Row>
      </If>
    );
  }
}

export default FilterBar;
